module.exports = __webpack_public_path__ + "static/media/icon-baby-orange.a120976c.svg";